export default __webpack_public_path__ + "static/media/Cobrança.05852e58.svg";